export const DEFAULT_NATIVE_ADDRESS_SOLANA = '11111111111111111111111111111111'
export const WRAPPED_SOL_ADDRESS_SOLANA = 'So11111111111111111111111111111111111111112'
